(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-supermarket"]) return;
  try {
    
   document.addEventListener('DOMContentLoaded', function() {
  var categoryNavItems = document.querySelectorAll('.cat-nav li');
  var innerWrappers = document.querySelectorAll('.inner-wrapper');
  var categoryImageLinks = document.querySelectorAll('.category-image');

  function hideAllSectionsAndImages() {
    // Hide all inner wrappers and image links
    innerWrappers.forEach(function(wrapper) {
      wrapper.style.display = 'none';
    });
    categoryImageLinks.forEach(function(link) {
      link.style.display = 'none';
    });
  }

  function setActiveCategory(targetId) {
    hideAllSectionsAndImages();

    // Show the target inner wrapper
    var activeWrapper = document.getElementById(targetId);
    if (activeWrapper) {
      activeWrapper.style.display = 'flex';
    }

    // Show the target image link
    var activeImageLink = document.querySelector(`a[id='${targetId}']`);
    if (activeImageLink) {
      activeImageLink.style.display = 'block';
    }

    // Set active class to the clicked category item
    categoryNavItems.forEach(function(item) {
      item.classList.remove('active');
      if (item.getAttribute('data-target') === targetId) {
        item.classList.add('active');
      }
    });
  }

  // Initial activation of the first category
  setActiveCategory('category-1');

  // Event listeners for category items
  categoryNavItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var targetId = item.getAttribute('data-target');
      setActiveCategory(targetId);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
